import { render } from "./Sidebar.vue?vue&type=template&id=1970342c&scoped=true"
import script from "./Sidebar.vue?vue&type=script&lang=js"
export * from "./Sidebar.vue?vue&type=script&lang=js"

import "./Sidebar.vue?vue&type=style&index=0&id=1970342c&lang=scss&scoped=true"
import "./Sidebar.vue?vue&type=style&index=1&id=1970342c&lang=scss"

import exportComponent from "D:\\Project\\KOMEF\\vuejs-heselcare\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1970342c"]])

export default __exports__